import { REQUEST_SELECTOR } from '../constants';

const loadRequestSelector = (request) => ({
    type: REQUEST_SELECTOR.REQUEST_SELECTOR_LOAD,
    payload : request
});

const loadRequestSelectorSuccess = (data) => ({
    type:REQUEST_SELECTOR.REQUEST_SELECTOR_SUCCESS,
    payload : data
});

const loadRequestSelectorFail = (error) => ({
    type: REQUEST_SELECTOR.REQUEST_SELECTOR_FAIL,
    payload : error
});

const loadRequestSelectorReset = () => ({
    type:REQUEST_SELECTOR.REQUEST_SELECTOR_RESET
});

export{
    loadRequestSelectorFail,
    loadRequestSelector,
    loadRequestSelectorReset,
    loadRequestSelectorSuccess
}